import React, {Component} from "react";
import { HashRouter, Route } from 'react-router-dom';

import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import MyAppBarAndMenu from "./components/AppBarAndMenu/AppBarAndMenu";
import Home from "./containers/Home";
import Source from "./containers/Source";
import Contents from "./containers/Contents";
import Resources from "./containers/Resources";
import Twitter from "./containers/Twitter";
import "./App.css";


class App extends Component {
    render() {
        return (
            <HashRouter>
                <MuiThemeProvider>
                    <div>
                        <MyAppBarAndMenu />
                        <Route exact path="/" component={Home} />
                        <Route name="source" path="/source" component={Source} />
                        <Route path="/contents" component={Contents} />
                        <Route path="/resources" component={Resources} />
                        <Route path="/twitter" component={Twitter} />
                    </div>
                </MuiThemeProvider>
            </HashRouter>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js